import React from 'react'

import { useQuery } from 'react-query'

import {

    PieChart,

    Pie,

    Cell,

    Tooltip,

    ResponsiveContainer

} from 'recharts'

import api from '../../api'

const CORES = [

    '#156082',

    '#e97132',

    '#196b24',

    '#2994c2',

    '#a02b93',

    '#4ea72e',

    '#d9a300',

    '#7f7f7f',

    '#5b9bd5',

    '#c55a11'

]

export default function DashboardGeracao({
    adesao_institucional_id,
    anos = [],
    modo = 'RELATORIO',
    exportandoPDF = false
}) {

    const anosSelecionados =

        Array.isArray(anos)

            ? anos

                .map(item =>

                    Number(item)

                )

                .filter(item =>

                    Number.isInteger(item) &&

                    item > 0

                )

            : []

    // =========================================================

    // CONSULTA

    // =========================================================

    const {

        data,

        isLoading,

        isFetching,

        isError

    } = useQuery({

        queryKey: [

            'residuosDashboardGeracao',

            adesao_institucional_id,

            anosSelecionados.join(','),

            modo

        ],

        queryFn: async () => {

            const params = {

                modo:

                    modo,

                ...(anosSelecionados.length > 0

                    ? {

                        anos:

                            anosSelecionados.join(',')

                    }

                    : {})

            }

            const result =

                await api.get(

                    `residuosDashboard/${adesao_institucional_id}`,

                    {

                        params

                    }

                )

            return result.data

        },

        enabled:

            !!adesao_institucional_id

    })

    // =========================================================

    // FORMATADORES

    // =========================================================

    const formataNumero = (valor) => {

        return Number(valor || 0).toLocaleString(

            'pt-BR',

            {

                minimumFractionDigits: 1,

                maximumFractionDigits: 2

            }

        )

    }

    const calculaTotal = (dados) => {

        return (dados || []).reduce(

            (total, item) =>

                total + Number(item.total || 0),

            0

        )

    }

    // =========================================================

    // LOADING

    // =========================================================

    if (isLoading || isFetching) {

        return (

            <div

className="text-center"

style={{

                    padding: '80px 0'

                }}

            >

                <i

className="fa fa-spinner fa-spin"

style={{

                        fontSize: '30px',

                        color: '#198754'

                    }}

                />

                <div

style={{

                        marginTop: '12px'

                    }}

                >

                    Carregando dashboard...

                </div>

            </div>

        )

    }

    // =========================================================

    // ERRO

    // =========================================================

    if (isError) {

        return (

            <div className="alert alert-danger">

                Não foi possível carregar os dados do dashboard.

            </div>

        )

    }

    // =========================================================

    // DADOS

    // =========================================================

    const grupos =

        data?.grupos || []

    const subgrupos =

        data?.subgrupos || []

    const tratamentos =

        data?.tratamentos || []

    // =========================================================

    // COMPONENTE DO GRÁFICO

    // =========================================================

    const GraficoPizza = ({

    titulo,

    dados,

    backgroundColor = '#ffffff'

}) => {

    const total = calculaTotal(dados)

    const dadosGrafico =

        dados.flatMap(

            (item, index) => {

                const totalItem =

                    Number(item.total || 0)

                const totalPendencia =

                    modo === 'CORRECAO'

                        ? Number(

                            item.totalPendencia || 0

                        )

                        : 0

                const totalNormal =

                    Math.max(

                        totalItem - totalPendencia,

                        0

                    )

                const itens = []

                if (totalNormal > 0) {

                    itens.push({

                        ...item,

                        valorGrafico:

                            totalNormal,

                        pendencia:

                            false,

                        corIndex:

                            index

                    })

                }

                if (totalPendencia > 0) {

                    itens.push({

                        ...item,

                        valorGrafico:

                            totalPendencia,

                        pendencia:

                            true,

                        corIndex:

                            index

                    })

                }

                return itens

            }

        )

    return (

        <div

style={{

                border: '1px solid #d7dce1',

                borderRadius: '14px',

                backgroundColor: backgroundColor,

                padding: '20px',

                height: '100%',

                minHeight: '520px',

                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'

            }}

        >

            {/* =====================================================

                TÍTULO

               \===================================================== */}

            <div

style={{

                    fontSize: '18px',

                    fontWeight: '700',

                    color: '#333',

                    marginBottom: '5px',

                    textAlign: 'center'

                }}

            >

                {titulo}

            </div>

            {dados.length === 0 ? (

                <div

className="text-muted text-center"

style={{

                        padding: '100px 0'

                    }}

                >

                    Nenhum dado disponível.

                </div>

            ) : (

                <>

                    {/* =================================================

                        GRÁFICO

                       \================================================= */}

                    <div

style={{

                            width: '100%',

                            height: '270px'

                        }}

                    >

                        <ResponsiveContainer

width="100%"

height="100%"

                        >

                            <PieChart>

                                <defs>

                                    {dados.map(

                                        (item, index) => (

                                            <pattern

key={`pattern-${index}`}

id={`pendencia-${index}`}

width="6"

height="6"

patternUnits="userSpaceOnUse"

patternTransform="rotate(45)"

                                            >

                                                <rect

width="6"

height="6"

fill={

                                                        CORES[

                                                            index %

                                                            CORES.length

                                                        ]

                                                    }

                                                />

                                                <line

x1="0"

y1="0"

x2="0"

y2="6"

stroke="#ffffff"

strokeWidth="2"

                                                />

                                            </pattern>

                                        )

                                    )}

                                </defs>

                                <Pie
                                    data={dadosGrafico}
                                    dataKey="valorGrafico"
                                    nameKey="descricao"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={105}
                                    innerRadius={0}
                                    paddingAngle={1}
                                    stroke="#ffffff"
                                    strokeWidth={2}
                                    isAnimationActive={!exportandoPDF}
                                >

                                    {dadosGrafico.map(

                                        (item, index) => (

                                            <Cell

key={`cell-${index}`}

fill={

                                                    item.pendencia

                                                        ? `url(#pendencia-${item.corIndex})`

                                                        : CORES[

                                                            item.corIndex %

                                                            CORES.length

                                                        ]

                                                }

                                            />

                                        )

                                    )}

                                </Pie>

                                <Tooltip

formatter={(

                                        value,

                                        name,

                                        props

                                    ) => {

                                        const item =

                                            props?.payload || {}

                                        const percentual =

                                            total > 0

                                                ? (

                                                    Number(value) /

                                                    total

                                                ) * 100

                                                : 0

                                        const situacao =

                                            item.pendencia

                                                ? ' — com pendência'

                                                : ''

                                        return [

                                            `${formataNumero(value)} kg (${percentual.toFixed(1)}%)${situacao}`,

                                            name

                                        ]

                                    }}

                                />

                            </PieChart>

                        </ResponsiveContainer>

                    </div>

                    {/* =================================================

                        LEGENDA

                       \================================================= */}

                    <div

style={{

                            marginTop: '5px',

                            paddingTop: '15px',

                            borderTop: '1px solid rgba(0,0,0,0.08)'

                        }}

                    >

                        <div className="row">

                            {dados.map(

                                (item, index) => {

                                    const percentual =

                                        total > 0

                                            ? (

                                                Number(item.total) /

                                                total

                                            ) * 100

                                            : 0

                                    return (

                                        <div

key={index}

className="col-md-6"

style={{

                                                marginBottom: '12px'

                                            }}

                                        >

                                            <div

style={{

                                                    display: 'flex',

                                                    alignItems: 'flex-start'

                                                }}

                                            >

                                                {/* COR */}

                                                <div

style={{

                                                        width: '11px',

                                                        height: '11px',

                                                        minWidth: '11px',

                                                        borderRadius: '3px',

                                                        backgroundColor:

                                                            CORES[

                                                                index %

                                                                CORES.length

                                                            ],

                                                        marginRight: '8px',

                                                        marginTop: '4px'

                                                    }}

                                                />

                                                {/* TEXTO */}

                                                <div

style={{

                                                        minWidth: 0

                                                    }}

                                                >

                                                    <div

style={{

                                                            fontSize: '12px',

                                                            lineHeight: '1.3',

                                                            fontWeight: '600',

                                                            color: '#333'

                                                        }}

                                                    >

                                                        {item.descricao}

                                                    </div>

                                                    <div

style={{

                                                            fontSize: '11px',

                                                            color: '#666',

                                                            marginTop: '2px'

                                                        }}

                                                    >

                                                        <strong>

                                                            {percentual.toFixed(1)}%

                                                        </strong>

                                                        {' • '}

                                                        {formataNumero(

                                                            item.total

                                                        )}

                                                        {' kg'}

                                                    </div>

                                                    {modo === 'CORRECAO' &&

                                                        Number(

                                                            item.totalPendencia || 0

                                                        ) > 0 && (

                                                            <div

style={{

                                                                    fontSize: '11px',

                                                                    color: '#d97706',

                                                                    marginTop: '3px',

                                                                    fontWeight: '600'

                                                                }}

                                                            >

                                                                <span

style={{

                                                                        display: 'inline-block',

                                                                        width: '10px',

                                                                        height: '10px',

                                                                        marginRight: '5px',

                                                                        verticalAlign: '-1px',

                                                                        border: '1px solid #d97706',

                                                                        background:

                                                                            'repeating-linear-gradient(45deg, transparent, transparent 2px, #d97706 2px, #d97706 3px)'

                                                                    }}

                                                                />

                                                                {formataNumero(

                                                                    item.totalPendencia

                                                                )} kg com pendência

                                                            </div>

                                                        )}

                                                </div>

                                            </div>

                                        </div>

                                    )

                                }

                            )}

                        </div>

                    </div>

                </>

            )}

        </div>

    )

}

const totaisAnuaisExibidos =

    anosSelecionados.length > 0

        ? (data?.totaisAnuais || [])

            .filter(item =>

                anosSelecionados.includes(

                    Number(item.ano)

                )

            )

        : data?.totaisAnuais || []

const rotuloPeriodo =

    anosSelecionados.length === 0

        ? 'todos os anos'

        : anosSelecionados.length === 1

            ? anosSelecionados[0]

            : `${anosSelecionados.length} anos selecionados`

    // =========================================================

    // DASHBOARD

    // =========================================================

    return (

        <div className="dashboard-geracao-exportavel">

            {/* =====================================================

                CONTEÚDO

               \===================================================== */}

            <div className="row">

                {/* =================================================

                    PESO TOTAL

                   \================================================= */}

                <div

className="col-md-3"

style={{

                        marginBottom: '20px'

                    }}

                >

                    <div

style={{

                            height: '100%',

                            minHeight: '350px',

                            border: '1px solid #d7dce1',

                            borderRadius: '12px',

                            backgroundColor: '#f8fbfd',

                            padding: '25px',

                            display: 'flex',

                            flexDirection: 'column',

                            justifyContent: 'center',

                            alignItems: 'center',

                            textAlign: 'center'

                        }}

                    >

                        <div

style={{

                                fontSize: '18px',

                                fontWeight: '600',

                                color: '#1683c7',

                                marginBottom: '20px'

                            }}

                        >

                            Peso Total

                        </div>

                        <div

style={{

                                fontSize: '42px',

                                fontWeight: '700',

                                color: '#222',

                                lineHeight: '1'

                            }}

                        >

                            {formataNumero(

                                data?.totalResiduos

                            )}

                        </div>

                        <div

style={{

                                marginTop: '10px',

                                fontSize: '20px',

                                fontWeight: '600',

                                color: '#666'

                            }}

                        >

                            kg

                        </div>

                        <div

style={{

                                marginTop: '20px',

                                fontSize: '12px',

                                color: '#888'

                            }}

                        >

                            Total informado em {rotuloPeriodo}

                        </div>

                        <div

style={{

                                marginTop: '6px',

                                fontSize: '11px',

                                color:

                                    modo === 'RELATORIO'

                                        ? '#198754'

                                        : '#d97706',

                                fontWeight: '600'

                            }}

                        >

                            {modo === 'RELATORIO'

                                ? 'Somente dados completos ou verificados'

                                : 'Todos os dados informados'}

                        </div>

                    </div>

                </div>

                {/* =================================================

                    GRUPO

                   \================================================= */}

                <div

className="col-md-3"

style={{

                        marginBottom: '20px'

                    }}

                >

                    <GraficoPizza

titulo="Composição por grupo"

dados={grupos}

                    />

                </div>

                {/* =================================================

                    SUBGRUPO

                   \================================================= */}

                <div

className="col-md-3"

style={{

                        marginBottom: '20px'

                    }}

                >

                    <GraficoPizza

titulo="Composição por subgrupo"

dados={subgrupos}

                    />

                </div>

                {/* =================================================

                    TRATAMENTO

                   \================================================= */}

                <div

className="col-md-3"

style={{

                        marginBottom: '20px'

                    }}

                >

                    <GraficoPizza

titulo="Tratamentos e destinações"

dados={tratamentos}

                    />

                </div>

            </div>

            {anosSelecionados.length !== 1 &&

                totaisAnuaisExibidos.length > 0 && (

    <div

style={{

            marginTop: '10px',

            marginBottom: '20px'

        }}

    >

        <div

style={{

                backgroundColor: '#42bec4',

                color: '#fff',

                fontSize: '16px',

                fontWeight: '600',

                textAlign: 'center',

                padding: '6px',

                borderRadius: '6px 6px 0 0'

            }}

        >

            Totais anuais

        </div>

        <div

className="table-responsive dashboard-geracao-tabela"

        >

            <table

className="table table-bordered"

style={{

                    marginBottom: 0,

                    backgroundColor: '#fff'

                }}

            >

                <thead>

                    <tr>

                        <th

style={{

                                minWidth: '150px',

                                textAlign: 'center'

                            }}

                        >

                            Indicador

                        </th>

                        {totaisAnuaisExibidos.map(item => (

                            <th

key={item.ano}

style={{

                                    textAlign: 'center'

                                }}

                            >

                                {item.ano}

                            </th>

                        ))}

                    </tr>

                </thead>

                <tbody>

                    <tr>

                        <td>

                            <strong>

                                Massa total (t)

                            </strong>

                        </td>

                        {totaisAnuaisExibidos.map(item => (

                            <td

key={item.ano}

style={{

                                    textAlign: 'right'

                                }}

                            >

                                <div>

                                    {(

Number(item.total) / 1000

                                    ).toLocaleString(

                                        'pt-BR',

                                        {

                                            minimumFractionDigits: 1,

                                            maximumFractionDigits: 1

                                        }

                                    )}

                                </div>

                                {modo === 'CORRECAO' &&

Number(

item.totalPendencia || 0

                                    ) > 0 && (

                                        <div

style={{

                                                marginTop: '4px',

                                                fontSize: '11px',

                                                color: '#d97706',

                                                fontWeight: '600',

                                                whiteSpace: 'nowrap'

                                            }}

                                        >

                                            <span

style={{

                                                    display: 'inline-block',

                                                    width: '10px',

                                                    height: '10px',

                                                    marginRight: '5px',

                                                    verticalAlign: '-1px',

                                                    border:

                                                        '1px solid #d97706',

                                                    background:

                                                        'repeating-linear-gradient(45deg, transparent, transparent 2px, #d97706 2px, #d97706 3px)'

                                                }}

                                            />

                                            {(

Number(

item.totalPendencia

                                                ) / 1000

                                            ).toLocaleString(

                                                'pt-BR',

                                                {

                                                    minimumFractionDigits: 1,

                                                    maximumFractionDigits: 1

                                                }

                                            )} t com pendência

                                        </div>

                                    )}

                            </td>

                        ))}

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

)}

        </div>

    )

}